import { FC } from 'react';

import { ReactComponent as ChevronLeft } from 'utils/assets/images/chevronLeft.svg';
import { ReactComponent as ChevronRight } from 'utils/assets/images/chevronRight.svg';

import styles from './Arrow.module.scss';

interface Props {
  onClick?: () => void;
  direction: 'right' | 'left';
}

export const Arrow: FC<Props> = ({ onClick, direction }) => {
  return (
    <button className={styles.arrow} onClick={onClick}>
      {direction === 'right' ? <ChevronRight /> : <ChevronLeft />}
    </button>
  );
};
